import { commonFilter } from './filter';

export default {
  pageName: 'home',
  pageId: '20001',
  pagePath: '/opinion/gamelist',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
